import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport, FaEraser, FaTrash } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm } from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';

class CategoriasMultiprofissional extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaCategoria = this.buscaCategoria.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            page_numb: 1,
            loading: true,
        };
    }

    componentDidMount(){
        this.consultaCategorias(this.state.busca, this.state.page_numb)
    }

    consultaCategorias(busca, page_numb=1){
        api.get(`/profissionais/categorias-multiprofissionais/?nome=${busca}&page=${page_numb}`)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar categoria multiprofissional, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    renderRows = () => {
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.nome}</td>
                <td>{item.slug}</td>
                <td className="text-end">
                    <Button variant="light" href={"/categorias-multiprofissional/edit/" + item.id} size="sm">
                        <FaRegEdit /> Editar
                    </Button>
                    <Button className="ms-3" variant="danger" size="sm" onClick={() => this.handleDelete(item.id)}>
                        <FaTrash/>
                    </Button>    
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={3}>Nenhuma categoria encontrada</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaCategorias(this.state.busca, num_page)
    };

    handleDelete = (id) => {
        Swal.fire({
            title: 'Tem certeza?',
            text: "Essa ação não poderá ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/profissionais/categorias-multiprofissionais/${id}`)
                .then(response => {
                    Swal.fire(
                        'Excluído!',
                        'Categoria Multiprofissional foi excluída com sucesso.',
                        'success'
                    );
                    this.consultaCategorias(this.state.busca, this.state.page_numb);
                })
                .catch(error => {
                    Swal.fire(
                        'Erro!',
                        'Ocorreu um problema ao excluir a categoria multiprofissional.',
                        'error'
                    );
                });
            }
        });
    }
    
    buscaCategoria(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaCategorias(this.state.busca)
    };

    limpaFiltro = () => {
        this.setState({
            busca: '',
        }, () => {
            this.consultaEspecialidades(this.state.busca, 1);
        })  
    }

    render() {
        if (!hasPerm('view_categorias_multiprofissional')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Categorias Multiprofissionais</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/categorias-multiprofissional/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Categoria Multiprofissional
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaCategoria}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="busca"
                                                                value={this.state.busca}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Nome da Categoria"
                                                                aria-label="Nome da Categoria"
                                                                aria-describedby="basic-addon2"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>

                                                <Button type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                                    <FaEraser /> Limpar Filtro
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Slug</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={3}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={3}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(CategoriasMultiprofissional);